<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.user')"
    resource="users"
    :export-props="{}"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { filterColumnsHash, columnsHash, formColumnsHash } from '../admin_configs/users/columns';
import { TAG_TYPE } from '@/constants';

@Component
export default class Users extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      { prop: 'screen_name_cont' },
      {
        prop: 'profile_gender_eq',
        label: this.$t('profile.gender'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: _.map(this.$t('profile.genders'), (label, value) => ({ value, label })),
          }
        }
      },
    ].filter(Boolean).map(hash => _.merge(filterColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      { prop: 'id' },
      { prop: 'avatar' },
      {
        prop: 'screen_name',
        renderCell: {
          component: (h, { props: { value, scope: { row } } }) => {
            if (row.sns_authorized) {
              return (<span>{value}</span>)
            } else {
              return <el-tag type='info'>{this.$t('unauthorized')}</el-tag>;
            }
          }
        }
      },
      {
        prop: 'profile.gender',
        label: this.$t('profile.gender'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <el-tag type={TAG_TYPE[value]}>{ this.$t(`profile.genders.${value}`) }</el-tag>;
          }
        }
      },
      type === 'show' && {
        prop: 'profile.name',
        label: this.$t('profile.name')
      },
      type === 'show' && {
        prop: 'profile.phone',
        label: this.$t('profile.phone')
      },
      type === 'show' && {
        prop: 'profile.city',
        label: this.$t('profile.city')
      },
      { prop: 'last_access_at' },
      { prop: 'created_at' },
      { prop: 'updated_at' },
    ].filter(Boolean).map(hash => _.merge(columnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
    ].filter(Boolean).map(hash => _.merge(formColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */

  // actions({ row }, { remove }) {
  //   return [
  //     {
  //       component: 'routeButton',
  //       props: {
  //         label: this.$t('edit'),
  //         to: { name: 'users.edit', params: { id: row.id } }
  //       }
  //     },
  //     {
  //       component: 'confirmButton',
  //       props: {
  //         label: this.$t('destroy'),
  //         type: 'danger',
  //         can: 'users.destroy'
  //       },
  //       on: {
  //         confirm: () => remove(row.id)
  //       }
  //     }
  //   ].filter(Boolean);
}

export const route = [
  {
    path: '/users',
    name: 'users.index',
    component: Users,
    props: {
      type: 'index',
    }
  },
  {
    path: '/users/new',
    name: 'users.new',
    component: Users,
    props: {
      type: 'new',
    }
  },
  {
    path: '/users/:id',
    name: 'users.show',
    component: Users,
    props: {
      type: 'show',
    }
  },
  {
    path: '/users/:id/edit',
    name: 'users.edit',
    component: Users,
    props: {
      type: 'edit'
    }
  }
]
</script>
